<div class="auth-page-container forgotPassword-wrapper bg-drop-red">
  <h2 mat-dialog-title class="join-header px-4 d-flex align-items-center justify-content-between event-header">
    <app-logo-header></app-logo-header>
  </h2>
  <hr class="mt-0 mb-2" />


  <div class="box-shadow-container center-div mt-fit landing-box">
    <div class="not-found-container">
      <h1>{{'fourZeroFour' | translate}}</h1>
      <h2>{{'oopsPage' | translate}}</h2>
      <p>{{'marketInsights' | translate}}</p>
      <p>{{'possibleDate' | translate}}</p>

      <a routerLink="/dashboard" class="home-button">{{'backToDashboard' | translate}}</a>
    </div>
  </div>
</div>